var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "MapboxWrapper",
    {
      ref: "mapWrapper",
      attrs: {
        mapId: _vm.mapId,
        accessToken: _vm.accessToken,
        mapStyle: _vm.mapStyle,
        mapOptions: _vm.mapOptions
      },
      on: {
        "update:mapStyle": function($event) {
          _vm.mapStyle = $event
        },
        "update:map-style": function($event) {
          _vm.mapStyle = $event
        },
        load: _vm.onMapLoaded
      }
    },
    [
      _vm._l(_vm.markers, function(marker) {
        return _c(
          "RtMarker",
          {
            key: "marker_" + marker.id,
            attrs: {
              type: marker.type,
              poiId: marker.id,
              coordinates: marker.center,
              draggable: marker.draggable,
              color: marker.color || "#9FA8DA"
            },
            on: { clicked: _vm.onMarkerClicked }
          },
          [
            marker.custom
              ? [
                  _c("div", { attrs: { slot: "marker" }, slot: "marker" }, [
                    marker.type === 0
                      ? _c("img", {
                          staticClass: "marker-image",
                          attrs: {
                            src: require("./marker/assets/waterpoint.png")
                          }
                        })
                      : marker.type === 1
                      ? _c("img", {
                          staticClass: "marker-image",
                          attrs: {
                            src: require("./marker/assets/alarmsystem.png")
                          }
                        })
                      : marker.type === 2
                      ? _c("img", {
                          staticClass: "marker-image",
                          attrs: {
                            src: require("./marker/assets/resource.png")
                          }
                        })
                      : marker.type === 3
                      ? _c("img", {
                          staticClass: "marker-image",
                          attrs: {
                            src: require("./marker/assets/objectplan.png")
                          }
                        })
                      : marker.type === 4
                      ? _c("img", {
                          staticClass: "marker-image",
                          attrs: { src: require("./marker/assets/user.png") }
                        })
                      : _c("img", {
                          staticClass: "marker-image",
                          attrs: {
                            src: require("./marker/assets/waterpoint.png")
                          }
                        })
                  ])
                ]
              : _vm._e(),
            _vm._v(" "),
            marker.popup &&
            _vm.selectedAccountId === marker.accountId &&
            (_vm.canEdit || _vm.canDelete)
              ? [
                  _c(
                    "RtPopup",
                    {
                      attrs: {
                        slot: "popup",
                        coordinates: marker.center,
                        closeButton: true,
                        closeOnClick: true,
                        offset: _vm.offset
                      },
                      slot: "popup"
                    },
                    [
                      _c("div", { staticClass: "context-menu" }, [
                        _vm.canEdit
                          ? _c(
                              "span",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.editItem(marker)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("txtMarkerEdit")))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.canDelete
                          ? _c(
                              "span",
                              {
                                on: {
                                  click: function($event) {
                                    return _vm.deleteItem(marker)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("txtMarkerDelete")))]
                            )
                          : _vm._e()
                      ])
                    ]
                  )
                ]
              : _vm._e()
          ],
          2
        )
      }),
      _vm._v(" "),
      _c(
        "RtPopup",
        {
          attrs: {
            coordinates: _vm.addMenu.center,
            closeButton: true,
            closeOnClick: false,
            offset: _vm.offset
          }
        },
        [
          _c("div", { staticClass: "context-menu" }, [
            _c("span", { on: { click: _vm.addMarker } }, [
              _vm._v(_vm._s(_vm.$t("txtMarkerAdd")))
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.markers, function(marker) {
        return _c("RtPath", {
          key: "path_" + marker.id,
          attrs: {
            coordinates: marker.history,
            visible: _vm.visiblePathPois.find(e => e.id === marker.id),
            dateFrom: _vm.dateFrom,
            dateTo: _vm.dateTo,
            dateCurrent: _vm.dateCurrent
          },
          on: {
            "update:dateFrom": function($event) {
              return _vm.$emit("update:dateFrom", $event)
            },
            "update:dateTo": function($event) {
              return _vm.$emit("update:dateTo", $event)
            },
            "update:dateCurrent": function($event) {
              return _vm.$emit("update:dateCurrent", $event)
            }
          }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }